export const PaymentRecordStatusTypes = {
  PAID: 1,
  CANCELED: 2,
  PENDING: 3,
  labels: {
    1: 'оплачен',
    2: 'отменён',
    3: 'ожидает',
  },
};

export const PAYMENT_RECORD_STATUS_OPTIONS = [
  { id: PaymentRecordStatusTypes.PAID, label: PaymentRecordStatusTypes.labels[1] },
  { id: PaymentRecordStatusTypes.CANCELED, label: PaymentRecordStatusTypes.labels[2] },
  { id: PaymentRecordStatusTypes.PENDING, label: PaymentRecordStatusTypes.labels[3] },
];
